module.exports = __webpack_public_path__ + "d90ee3bf81599fca491a22daf3250526.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile/Yabuuchi.jpg
// module id = 101
// module chunks = 0